import { render, staticRenderFns } from "./VineyardQuestion.vue?vue&type=template&id=19a1a060&scoped=true&"
import script from "./VineyardQuestion.vue?vue&type=script&lang=js&"
export * from "./VineyardQuestion.vue?vue&type=script&lang=js&"
import style0 from "./VineyardQuestion.vue?vue&type=style&index=0&id=19a1a060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a1a060",
  null
  
)

export default component.exports